import ReactSelect from 'react-select';
import PropTypes from 'prop-types';

export const BuildingBrightness = ({
  values,
  handleChangeCaracObj,
  errors,
  touched
}) => {
  const options = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'Muy luminoso' },
    { value: 2, label: 'Luminoso' },
    { value: 3, label: 'Poco luminoso' }
  ];
  return (
    <div>
      <label>Luminosidad de la propiedad</label>
      <ReactSelect
        name="buildingBrightness"
        placeholder="-- Seleccione la Luminosidad --"
        options={options}
        value={options.find(v => v.value === values)}
        onChange={e => {
          handleChangeCaracObj(
            'buildingBrightness',
            e?.value && Number(e.value)
          );
        }}
      />
      {errors?.type && touched?.type && (
        <label className="w-100 text-danger">{errors.type}</label>
      )}
    </div>
  );
};
BuildingBrightness.propTypes = {
  values: PropTypes.object,
  handleChangeCaracObj: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
